import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/reactPolyfill'; // Import polyfill before other components
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
